import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { AgencyPartners } from './pages/AgencyPartners'
import { Agency } from './pages/Agency'
import { Affiliate } from './pages/Affiliate'
import { Privacy } from './pages/Privacy'

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agency-partners" element={<AgencyPartners />} />
          <Route path="/agency" element={<Agency />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/partners" element={<Navigate to="/affiliate" replace />} />
          <Route path="/affiliates" element={<Navigate to="/affiliate" replace />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default App
